/**
 * inputBooleanSelectDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

export function inputBooleanSelectDirective() {
    return {
        restrict: 'E',
        transclude: true,
        //language=HTML
        template: `
            <md-input-container>
                <label>{{ label }}</label>

                <md-select name="{{ name }}"
                           aria-label="{{ label }}"
                           md-on-close="_onClose()"
                           ng-change="_onChange()"
                           ng-model="value"
                           ng-model-options="ngModelOptions"
                           ng-disabled="disabled"
                           ng-required="required"
                           placeholder="{{ placeholder }}">

                    <ng-transclude></ng-transclude>

                    <md-option class="app-input-select-option"
                               ng-repeat="option in options track by option.value"
                               ng-value="option.value"
                               summary="{{ option.summary }}">
                        <div>{{ option.label }}</div>
                        <small ng-if="option.details">{{ option.details }}</small>
                    </md-option>
                </md-select>

                <div class="hint" ng-if="hint">{{ hint }}</div>

                <div ng-if="form && name" ng-messages="form[name].$error">
                    <div ng-message="required">Required</div>
                    <div ng-repeat="(key, message) in errorMessages" ng-message="{{ key }}">{{ message }}</div>
                </div>
            </md-input-container>

            <md-button class="md-icon-button app-form-field-clear"
                       ng-if="isClearable"
                       ng-disabled="value === undefined"
                       ng-click="clear()">
                <md-icon>clear</md-icon>
            </md-button>
        `,
        scope: {
            isClearable: '=?clearable',
            disabled: '=ngDisabled',
            errorMessages: '=errorMessages',
            form: '=form',
            label: '@label',
            name: '@name',
            hint: '@name',
            ngModelOptions: '=?ngModelOptions',
            noFloat: '=?noFloat',
            onChange: '&?change',
            options: '=?options',
            placeholder: '@?placeholder',
            required: '=?required',
            value: '=value',
        },
        link: function(scope, element, attrs) {
            element.addClass('app-form-field');
            element.addClass('app-form-select');

            scope.clear = clear;
            scope._onChange = _onChange;
            scope._onClose = onSelectClosed;

            // If it's undefined on the scope, it may mean that the attribute is there but
            // without content. If the attribute isn't undefined then we know it's been added.
            if (scope.required === undefined && attrs.required !== undefined) {
                scope.required = true;
            }

            if (scope.noFloat === undefined && attrs.noFloat !== undefined) {
                scope.noFloat = true;
            }

            if (scope.options === undefined) {
                scope.options = [{ value: true, label: 'True' }, { value: false, label: 'False' }];
            }

            function clear() {
                scope.value = undefined;

                _onChange();
            }

            function _onChange() {
                if (angular.isFunction(scope.onChange)) {
                    scope.onChange();
                }
            }

            function onSelectClosed() {
                const hasValue = !!scope.value;

                hasValue ? element.addClass('filled') : element.removeClass('filled');
            }
        },
    };
}
